import localforage from "localforage";

export const LAST_REFRESH_TIME = "lastRefreshTime";

export const setLastRefreshTime = async (value) => {
  try {
    await localforage.setItem(LAST_REFRESH_TIME, value);
  } catch (error) {
    console.error("Failed to set last refresh time:", error);
  }
};

export const getLastRefreshTime = async () => {
  try {
    const value = await localforage.getItem(LAST_REFRESH_TIME);
    return value;
  } catch (error) {
    console.error("Failed to get last refresh time:", error);
    return null;
  }
};

export const removeLastRefreshTime = async () => {
  try {
    window.localStorage.removeItem(LAST_REFRESH_TIME);
    await localforage.removeItem(LAST_REFRESH_TIME);
  } catch (error) {
    console.error("Failed to remove last refresh time:", error);
  }
};
